module.exports = __webpack_public_path__ + "img/02.b4748e02.png";